import { SET_LOADING } from './actionTypes';

const INIT_STATE = {};

const loader = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default loader;
